import { render, staticRenderFns } from "./remaining-life-summary.vue?vue&type=template&id=7645625f"
import script from "./remaining-life-summary.ts?vue&type=script&lang=ts&external"
export * from "./remaining-life-summary.ts?vue&type=script&lang=ts&external"
import style0 from "./remaining-life-summary.less?vue&type=style&index=0&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7645625f')) {
      api.createRecord('7645625f', component.options)
    } else {
      api.reload('7645625f', component.options)
    }
    module.hot.accept("./remaining-life-summary.vue?vue&type=template&id=7645625f", function () {
      api.rerender('7645625f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/summary/remaining-life/remaining-life-summary.vue"
export default component.exports